export default __webpack_public_path__ + "static/media/showcase-dinner-room.df1c7c68.jpg";